(ns ballot-scout-v2-frontend.components.click-outside
  (:require
   [clojure.string :as str]
   [reagent.core :as r]))

(defn- ignored?
  "Returns true if the passed in target is one of or a descendant of one of the
  elements matching the ignored selectors."
  [ignored-selectors target]
  (->> (str/join "," ignored-selectors)
       (.querySelectorAll js/document)
       (js/Array.from)
       (some #(or (identical? % target)
                  (.contains % target)))
       boolean))

(defn click-outside
  "Returns a component that wraps another component and adds an on-click-outside
   handler which is triggered when the user clicks outside of the given component.

   Takes the following keyword arguments:
   - on-click-outside: a function that is called on the click event when user
   clicks outside the component
   - trigger-on-escape?: whether to trigger the click-outside handler when the ESC key
   is pressed"
  [{:keys [on-click-outside trigger-on-escape?]} & [component-to-wrap]]
  (r/with-let [container (r/atom nil)
               set-container (fn [ref] (reset! container ref))
               handler (fn [e]
                         (let [event-type (.-type e)
                               ignored-sels [".ignore-click-outside"]
                               target (.-target e)
                               ignore-target? (ignored? ignored-sels target)]
                           (condp = event-type
                             "click" (when (and @container
                                                (not (.contains @container target))
                                                (not ignore-target?))
                                       (on-click-outside e))
                             "keydown" (when (and trigger-on-escape? (= (.-keyCode e) 27))
                                         (on-click-outside e)))))
               _ (doto js/document
                   (.addEventListener "click" handler true)
                   (.addEventListener "keydown" handler true))]
    (component-to-wrap set-container)
    (finally
      (doto js/document
        (.removeEventListener "click" handler true)
        (.removeEventListener "keydown" handler true)))))
